/*** IMPORTS FROM imports-loader ***/
var global = window;

var toSentence = require('./toSentence');

module.exports = function toSentenceSerial(array, sep, lastSep) {
  return toSentence(array, sep, lastSep, true);
};

